import './ProductsItem.scss';

import cn from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import Button from '@/common/components/atoms/Button/Button';
import { ROUTE_NODES } from '@/common/constants';
import getImageBySize from '@/common/helpers/getImageBySize';
import useBreakpoints from '@/common/hooks/useBreakpoints';
import { MENU_CATEGORIES_FORMAT } from '@/ebat/constants';

// eslint-disable-next-line import/no-cycle
import ProductList from '../ProductList/ProductList';
import {
  ProductItemDefaultProps,
  ProductItemPropTypes,
} from './ProductItem.proptypes';

const ProductItem = ({ className, item, selectedItem, onSelect }) => {
  const { isMaxDesktop } = useBreakpoints();
  const isOpen =
    !item.isLeaf &&
    selectedItem !== null &&
    (selectedItem.id === item.id ||
      selectedItem.parents[item.depth] === item.id);

  const Content = (
    <>
      {item.depth <= 0 && item.image && item.image.url && (
        <img
          src={getImageBySize(item.image.url, MENU_CATEGORIES_FORMAT)}
          alt={item.image.alt ?? ''}
          className="product-menu-item__icon"
        />
      )}
      <span className="product-menu-item__label">{item.name ?? null}</span>
    </>
  );

  return (
    <li
      className={cn(className, 'product-menu-item', {
        'product-menu-item--open': isOpen,
      })}
      data-qa-id="product-menu-item"
    >
      {item.isLeaf ? (
        <NavLink
          className="product-menu-item__link"
          data-qa-id="product-menu-item-link"
          onClick={() => onSelect(item)}
          to={`${ROUTE_NODES}/${item.path}`}
        >
          {Content}
        </NavLink>
      ) : (
        <Button
          className={cn('product-menu-item__link', {
            active: isOpen,
          })}
          context="product-menu-item-btn"
          onClick={() => onSelect(item)}
        >
          {Content}
        </Button>
      )}
      <TransitionGroup component={null}>
        <ProductList
          isOpen={isOpen && isMaxDesktop}
          isRoot={false}
          items={item.children}
          parent={item}
          selectedItem={selectedItem}
          onSelect={onSelect}
        />
      </TransitionGroup>
    </li>
  );
};

ProductItem.defaultProps = {
  ...ProductItemDefaultProps,
};

ProductItem.propTypes = {
  ...ProductItemPropTypes,
};

export default ProductItem;
